import React, { FC } from "react";
import { GetServerSideProps } from "next";
import { CheckoutContext } from "v3/context/checkout";
import { CheckoutErrorContext } from "v3/context/checkoutError";
import { PaymentContext } from "v3/context/payment";
import { useCheckoutErrorProvider } from "v3/context/hooks/useCheckoutErrorProvider";
import { useCheckoutProvider } from "v3/context/hooks/useCheckoutProvider";
import { usePaymentProvider } from "v3/context/hooks/usePaymentProvider";
import { CheckoutPageWrapper } from "v3/components/checkout/CheckoutPageWrapper";
import { CheckoutContainer } from "v3/components/checkout/CheckoutContainer";
import { Signifyd } from "v3/components/checkout/Signifyd";
import { getBasePath } from "v3/helpers/api";

export interface CheckoutPageProps {
  apiBaseUrl: string;
  cartId: string;
}

export const getServerSideProps: GetServerSideProps<
  CheckoutPageProps
> = async ({ params, req }) => {
  const cartId = (params?.cartId as string) || "";

  return {
    props: {
      apiBaseUrl: getBasePath(req),
      cartId,
    },
  };
};

const Checkout: FC<CheckoutPageProps> = ({ apiBaseUrl, cartId }) => {
  const { paymentContextValue } = usePaymentProvider();
  const { checkoutErrorContextValue } = useCheckoutErrorProvider();
  const { checkoutContextValue } = useCheckoutProvider(apiBaseUrl);

  return (
    <CheckoutPageWrapper title="Secure Checkout">
      <PaymentContext.Provider value={paymentContextValue}>
        <CheckoutErrorContext.Provider value={checkoutErrorContextValue}>
          <CheckoutContext.Provider value={checkoutContextValue}>
            <Signifyd orderSessionId={cartId} />
            <CheckoutContainer cartId={cartId} />
          </CheckoutContext.Provider>
        </CheckoutErrorContext.Provider>
      </PaymentContext.Provider>
    </CheckoutPageWrapper>
  );
};

export default Checkout;
